import HttpService from '@/common/services/HttpService'
import { type ActivityDTOV1 } from '@/common/types/activity'

const serviceRoot = '/agent-activity/api/v1/status'

export const getCurrentAgentActivity = () => {
  return HttpService.getData<ActivityDTOV1>(`${serviceRoot}`)
}

export const updateCurrentAgentActivity = async (id: UUID | null) => {
  return HttpService.post(`${serviceRoot}`, { activityId: id })
}
